<template>
  <div class="value-service" style="position:relative;padding-bottom:70px;">
    <div style="color:rgba(51, 51, 51, 1);font-size:18px;background:#fff;height:58px;line-height:58px;padding-left:24px;margin-left:1px;font-weight:bold">
      <a-icon style="margin-right:5px" type="calendar" />
      增值服务
    </div>
    <div style="padding:8px 24px 24px;">
      <div style="margin-top:16px;background:#fff;padding-top:16px;" v-for="(item, index) in serviceList" :key="index">
        <div style="display:flex;padding-right:24px;">
          <div style="flex:1;height:30px;padding:0 24px;">
            <a-checkbox v-model="item.show" style="float:left;margin-top:4px" @change="e=>onChange(e,index)"></a-checkbox>
            <span style="color:rgba(51, 51, 51, 1);font-size:18px;float:left;font-weight:bold">{{item.name}}</span>
            <span style="color:rgba(34, 215, 187, 1);font-size:14px;float:left;margin-top:3px;font-weight:bold">{{item.price}}元</span>
          </div>
          <div style="width:100px;color:rgba(34, 215, 187, 1);font-size:14px;text-align:right;cursor:pointer">
            <span @click="viewDetail(item)">查看详情</span>
            <a-icon type="right" />
          </div>
        </div>
        <div>
          <a-divider style="margin:16px 0 0 0" />
          <div style="padding:16px 24px">
            <div style="color:rgba(204, 204, 204, 1);font-size:14px;margin-top:16px;flex:1">
              {{item.introduction}}
            </div>
          </div>
          <div v-if="item.show" style="margin-top:24px;padding:0 24px 24px">
            <span style="color:rgba(128, 128, 128, 1);fon-size:14px;float:left;;margin-top:3px">数量：</span>
            <a-input-number @change="changeDays(index,item.days)" v-model="item.days" style="height:30px;border-color:rgba(240, 240, 240, 1);width:94px;" :min="1" :max="1000" />
          </div>
        </div>
      </div>
    </div>
    <div style="margin:0 24px;background:#fff;">
      <div style="padding:16px 24px">
        <span style="width:170px;color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">增值服务套餐总计：</span>
        <span style="color:rgba(34, 215, 187, 1);font-size:18px;font-weight:bold">￥{{totalPrice}}.00</span>
        <a-icon v-if="ifShow" @click="hideDetail()" style="float:right;font-size:18px;cursor:pointer" type="down" />
        <a-icon v-if="!ifShow" @click="hideDetail()" style="float:right;font-size:18px;cursor:pointer" type="up" />
      </div>
      <div v-if="ifShow">
        <a-divider style="margin:0 0 24px 0" />
        <div style="display:flex;padding:0 24px 24px">
          <div style="width:162px;color:rgba(51, 51, 51, 1);font-size:16px;">消费明细：</div>
          <div style="flex:1">
            <div style="color:rgba(153, 153, 153, 1);font-size:14px;" v-for="(item, index) in serviceList" :key="index">
            <div v-if="item.show">
              {{item.name}}*{{item.days}}（{{item.price*item.days}}元）
            </div>
          </div>
          <a-button type="primary" v-if="totalPrice!=0" @click="submitOrder" style="display:inline-block;width:88px;height:32px;line-height:32px;background:rgba(34, 215, 187, 1);border-radius:4px;cursor:pointer;margin-top:16px;">提交订单</a-button>
          </div>
        </div>
      </div>
     

    </div>
    <a-modal
      title="增值服务详情介绍"
      :visible="detailModal"
      :footer="null"
      width='800px'
      @cancel="detailCancel"
    >
      <div>
        <div>
          <span style="color:rgba(51, 51, 51, 1);font-size:18px">{{currentDetailInfo.name}}</span>
          <span style="color:rgba(34, 215, 187, 1);font-size:14px;margin-left:12px;">{{currentDetailInfo.price}}元</span>
        </div>
        <div style="margin-top:24px;">
          <div style="color:rgba(102, 102, 102, 1);font-size:16px;">标题</div>
          <div style="color:rgba(204, 204, 204, 1);font-size:14px;margin-top:8px;">
            {{currentDetailInfo.detail}}
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      title="增值服务付款"
      :visible="payModal"
      :footer="null"
      width='540px'
      @cancel="payCancel"
    >
      <div>
        <div>
          <a-icon type="warning" style="color:rgba(255, 170, 0, 1);font-size:22px"/>
          <span style="color:rgba(80, 80, 80, 1);font-size:18px;margin-left:16px">请您确认订单，并付款</span>
        </div>
        <div style="display:flex;margin-top:24px">
          <div style="width:98px;color:rgba(51, 51, 51, 1);font-size:14px;">确认订单信息：</div>
          <div style="flex:1;color:rgba(153, 153, 153, 1);font-size:14px;">
            <!-- <div v-for="(item, index) in 3" :key="index">基础场景定制*10天（20000元）</div> -->
            <div v-for="(item, index) in serviceList" :key="index">
              <div v-if="item.show">
                {{item.name}}*{{item.days}}天（{{item.price*item.days}}元）
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top:24px;">
          <span style="width:98px;color:rgba(51, 51, 51, 1);font-size:14px;display:inline-block">总计付款金额：</span>
          <span style="color:rgba(34, 215, 187, 1);font-size:18px;">￥{{totalPrice}}.00</span>
        </div>
        <div style="margin-top:24px;">
          <span style="width:98px;color:rgba(51, 51, 51, 1);font-size:14px;display:inline-block">确认账户密码：</span>
          <a-input placeholder="请输入密码" type="password" style="width:380px;height:40px;" v-model="password">
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </div>
        <div style="font-size:14px;margin-top:24px;text-align:right">
          <span @click="payCancel" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:rgba(34, 215, 187, 1);margin-right:16px;cursor:pointer">取消</span>
          <span @click="paySure" style="display:inline-block;width:80px;height:34px;line-height:34px;text-align:center;border-radius:4px;border:1px solid rgba(34, 215, 187, 1);color:#fff;background:rgba(34, 215, 187, 1);cursor:pointer">确认</span>
        </div>
      </div>
    </a-modal>
    <a-alert
      v-if="payState=='success'"
      style="position:fixed;left:50%;width:324px;top:30%;height:106px;margin-left:-162px;margin-top:-70px;"
      message="付款成功"
      description="您可在“我的账户”中查看此消费记录"
      type="success"
      show-icon
    />
    <a-alert
      v-if="payState=='error'"
      style="position:fixed;left:50%;width:324px;top:30%;height:106px;margin-left:-162px;margin-top:-70px;"
      message="付款失败"
      :description="payErrorDes"
      type="error"
      show-icon
    />
  </div>
</template>

<script>
/*
  serviceList => [
    {
      show: true,
      days: 1
    }
  ]
*/
export default {
  name: 'ValueService',
  props: {
    msg: String
  },
  data() {
    return {
      detailModal: false,
      payModal: false,
      payState: '',
      payErrorDes: '',
      serviceList: [],
      currentDetailInfo: '',
      totalPrice: 0,
      password: '',
      ifShow: true
    };
  },
  methods: {
    onChange(e,index) {
      this.totalPrice = 0
      this.serviceList[index]['show'] = e.target.checked
      for(let i = 0; i < this.serviceList.length; i++){
        if(this.serviceList[i]['show']){
          this.totalPrice += this.serviceList[i]['days']*this.serviceList[i]['price']
        }
      }
      this.$forceUpdate()
    },
    viewDetail(item) {
      this.detailModal = true;
      this.currentDetailInfo = item
    },
    detailCancel() {
      this.detailModal = false;
    },
    payCancel() {
      this.payModal = false;
    },
    submitOrder() {
      this.payModal = true;
    },
    paySure() {
      let arr = []
      for(let i = 0; i < this.serviceList.length; i++){
        if(this.serviceList[i]['show']){
          let obj = {}
          obj.id = this.serviceList[i].id
          obj.days = this.serviceList[i].days
          arr.push(obj)
        }
      }
      this.payModal = false;
      this.axios.post('/api/extraServer', {
        extraServerList: arr,
        password: this.password,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.payState = 'success'
          setTimeout(()=>{
            this.payState = ''
          },1500)
        }else{
          this.payErrorDes = response.data.message
          this.payState = 'error'
          setTimeout(()=>{
            this.payState = ''
          },1500)
        }
        for(let i = 0; i < this.serviceList.length; i++){
          this.serviceList[i]['show'] = false
          this.serviceList[i]['days'] = 1
        }
        this.$forceUpdate()
        this.totalPrice = 0
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryServiceList() {
      this.axios(
        {
          method:'get',
          url:'/api/extraServer/list',
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.serviceList = response.data.data
          for(let i = 0; i < this.serviceList.length; i++){
            this.serviceList[i]['show'] = false
            this.serviceList[i]['days'] = 1
          }
        }else{
          this.$message.error(response.data.message);
          
          
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    changeDays(index,days) {
      this.serviceList[index]['days'] = days
      this.totalPrice = 0
      for(let i = 0; i < this.serviceList.length; i++){
        if(this.serviceList[i]['show']){
          this.totalPrice += this.serviceList[i]['days']*this.serviceList[i]['price']
        }
      }
      this.$forceUpdate()
    },
    hideDetail() {
      this.ifShow = !this.ifShow
    }
  },
  mounted: function() {
    this.sessionData('set','leftNavItem','valueService');
    this.queryServiceList()
  }
}
</script>

<style scoped lang="less">
  .value-service{
    // background: #fff;
  }
</style>
